import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Col, Grid, Row } from 'react-flexbox-grid';
import PreEFormFields from '../PreEFormFields';
import { Breadcrumb } from 'antd';
import Button from '../../../components/Button';
import { isViewOnlyOrExternalView } from '../../../utils/UserInfo';
import Errors from '../../../components/Errors';
import { Spinner } from 'react-bootstrap';
import { projectStatusCodeMap } from '../../../components/ProjectStatusCodeMap';
import { FORM_MODE_EDIT, FORM_MODE_NEW, FORM_MODE_VIEW } from '../index';

function PreEFormDetails(props) {
  const {
    location,
    history,
    project,
    status,
    preEForm,
    preEFormMappings,
    saveVisibleText,
    onCloseBox,
    error,
    onChangeFormTitle,
    onChangeReqSos,
    onChangePreEDate,
    onChangeAssetId,
    toggleAccordion,
    selectAllAssets,
    assets,
    onChangeEnergizedCheckBox,
    formMode,
    handlePreExceptionBack,
    onSave
  } = props;

  useEffect(() => {
    async function onComponentMount() {
      if (preEForm === null) {
        history.push(`/${status}/${project.id}/peform`)  
      }
      }

    onComponentMount();
  }, []);

  function getFormModeText() {
    switch (formMode) {
      case FORM_MODE_EDIT:
        return 'Edit';
      case FORM_MODE_NEW:
        return 'New';
      default:
        return 'View';
    }
  }

  function handleEditSave() {
      onSave(project.id);
  }

  return (
    <div className='container-fluid'>
      <Errors error={error}
              onCloseBox={onCloseBox} />
      <div  id={'PreEForm'}>
        <Row>
          <Col md={4} xs={12}>
            <Breadcrumb>
              <Breadcrumb.Item onClick={handlePreExceptionBack} href=''>
                PreEnergization Form
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {preEForm && getFormModeText()}
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        {!preEForm &&
          <Row>
            <Col xs={12} style={{ display: 'flex', justifyContent: 'center', padding: 64 }}>
              <Spinner animation='border' variant='primary' />
            </Col>
          </Row>
        }
        {preEForm &&
          <>
            <PreEFormFields props={props}
                            onChangeFormTitle={onChangeFormTitle}
                            onChangeReqSos={onChangeReqSos}
                            onChangePreEDate={onChangePreEDate}
                            preEForm={preEForm}
                            preEFormMappings={preEFormMappings}
                            onChangeAssetId={onChangeAssetId}
                            toggleAccordion={toggleAccordion}
                            selectAllAssets={selectAllAssets}
                            assets={assets}
                            saveVisibleText={saveVisibleText}
                            onChangeEnergizedCheckBox={onChangeEnergizedCheckBox}
                            formMode={formMode}
                            project={project} />
            <Row className='task--controls'>
              {(formMode === FORM_MODE_VIEW) && !saveVisibleText &&
              <Col xs={12} md={2}>
                <Button onClickHandler={handlePreExceptionBack}>Close</Button>
              </Col>
              }
              {((formMode === FORM_MODE_NEW || formMode === FORM_MODE_EDIT) || (saveVisibleText)) && (project.projectStatus !== projectStatusCodeMap['CLOSED'] && !isViewOnlyOrExternalView()) &&
              <>
                <Col xs={12} md={2}>
                  <Button onClickHandler={handleEditSave}>Save</Button>
                </Col>
                <Col xs={12} md={2}>
                  <Button onClickHandler={handlePreExceptionBack}>Cancel</Button>
                </Col>
              </>
              }
            </Row>
          </>
        }
      </div>
    </div>
  );
}

export default withRouter(PreEFormDetails);
